import React from 'react';
import { Col, Layout, Row, Typography } from 'antd';
import GreetingsTop from '../../../../components/Admin/GreetingsTop/GreetingsTop';
import { useHistory } from 'react-router';
import AddEditOperationForm from '../../../../components/Logistic/Operations/AddEditOperationForm';
import BackButton from '../../../../components/General/BackButton/BackButton';

export default function AddOperationPage() {
  return (
    <Layout>
      <GreetingsTop />
      <HeaderTop />
      <div className="billing__container">
        <AddEditOperationForm />
      </div>
    </Layout>
  );
}

function HeaderTop() {
  const { Title } = Typography;

  return (
    <div className="billing__container">
      <Row className="header-top">
        <Col xs={18} md={12} className="header-top__left">
          <Title
            level={3}
            style={{
              // position: 'absolute',
              top: 0,
              bottom: 0,
              height: '78%',
              margin: 'auto',
            }}
          >
            Agregar operación
          </Title>
        </Col>

        <Col xs={6} md={11}>
          <Row
            style={{
              marginBottom: 30,
              justifyContent: 'right',
            }}
          >
            <BackButton routeName={'/operaciones'}></BackButton>
          </Row>
        </Col>
      </Row>
    </div>
  );
}
